import React from 'react';

import WorkingHoursContext from '../../working-hours-context';

import { IconButton } from '../../../../../components';

import Time from '../../../../../components/time';
import TimeActions from '../../time-actions';

import {
  updateTimeRange,
  addNewTimeRange,
  removeTimeRange,
} from './helpers';

import {
  StyledTimeRange,
} from './time-range-styles';

const TimeRange = ({
  open,
  close,
  dropDownToBottom,
  timeRange,
  dayTitle,
  changeIsOpenDay,
  timesCount,
}) => {
  const [timeOpen, setTimeOpen] = React.useState(open);
  const [timeClose, setTimeClose] = React.useState(close);

  const { setWorkingHoursPerDay } = React.useContext(WorkingHoursContext);

  const updateTimeInitialValue = {
    workingHoursStateData: setWorkingHoursPerDay,
    dayTarget: dayTitle,
    dayTargetTimeRange: timeRange,
  };

  const updateOpenTimeRange = updateTimeRange({ ...updateTimeInitialValue, keyTime: 'open' });
  const updateCloseTimeRange = updateTimeRange({ ...updateTimeInitialValue, keyTime: 'close' });

  const handleSetTimeOpen = newOpenTimeValue => {
    setTimeOpen(newOpenTimeValue);
    updateOpenTimeRange(newOpenTimeValue);
  };

  const handleSetTimeClose = newCloseTimeValue => {
    setTimeClose(newCloseTimeValue);
    updateCloseTimeRange(newCloseTimeValue);
  };

  const handleDeleteTime = () => {
    if (timesCount === 1) {
      changeIsOpenDay({
        workingHoursStateData: setWorkingHoursPerDay,
        dayTarget: dayTitle,
        isOpen: false,
      });
      updateCloseTimeRange('00:00');
      updateOpenTimeRange('00:00');

      return;
    }

    removeTimeRange({
      workingHoursStateData: setWorkingHoursPerDay,
      dayTarget: dayTitle,
      timeRange,
    });
  };

  const handleAddNewTimeRange = () => {
    addNewTimeRange({
      workingHoursStateData: setWorkingHoursPerDay,
      dayTarget: dayTitle,
    });
  };

  return (
    <StyledTimeRange>
      <Time
        className="time"
        label="Abre"
        dropDownToBottom={dropDownToBottom}
        timeValue={timeOpen}
        setTimeValue={handleSetTimeOpen}
        type="open"
        timeRange={timeRange}
      />
      <Time
        className="time"
        label="Fecha"
        dropDownToBottom={dropDownToBottom}
        timeValue={timeClose}
        setTimeValue={handleSetTimeClose}
        type="close"
        timeRange={timeRange}
      />
      <TimeActions
        handleAddNewTimeRange={handleAddNewTimeRange}
        handleDeleteTimeRange={handleDeleteTime}
      />
    </StyledTimeRange>
  );
};

export default TimeRange;
